import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import Url from "../global";
import { exportTableToExcel } from "../utils/exportTableToExcel";
import "./globalList.scss";
import * as FaIcons from "react-icons/fa";

const RiwayatKepangkatanList = () => {
  const [riwayatKepangkatans, setRiwayatKepangkatan] = useState([]);
  const { pegawai } = useSelector((state) => state.auth);
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");

  const [order, setOrder] = useState("ASC");

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...riwayatKepangkatans].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatKepangkatan(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...riwayatKepangkatans].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatKepangkatan(sorted);
      setOrder("ASC");
    }
  };

  useEffect(() => {
    getRiwayatKepangkatan();
  }, []);

  const getRiwayatKepangkatan = async () => {
    const response = await axios.get(`${Url}/riwayat_kepangkatans`);
    setRiwayatKepangkatan(response.data);
  };

  const deleteRiwayatKepangkatan = async (riwayatKepangkatanId) => {
    await axios.delete(`${Url}/riwayat_kepangkatans/${riwayatKepangkatanId}`, {
      credentials: "include",
    });
    getRiwayatKepangkatan();
  };

  const download = (e) => {
    console.log(e.target.href);
    fetch(e.target.href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const blob = new Blob([buffer]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Sertifikat Kepangkatan.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <h1 className="title">Riwayat Kepangkatan</h1>
      {/* <h2 className="subtitle">List Of Riwayat Kepangkatan</h2> */}

      {pegawai &&
        (pegawai.strRole === "user" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "staff TU" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "admin") && (
          <Link
            to="/riwayat-kepangkatan/add"
            className="button is-primary mb-2"
          >
            Add New Riwayat Kepangkatan
          </Link>
        )}

      <button
        type="button"
        className="download-table-xls-button"
        onClick={() =>
          exportTableToExcel({
            tableId: "table-to-xls",
            filename: "Table Riwayat Kepangkatan",
          })
        }
      >
        Download as XLS
      </button>
      <br />
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && <label> Masukan Nama </label>}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Nama Individu"
            onChange={(e) => setQuery(e.target.value.toLowerCase())}
          />
        )}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <label className="label-unit">Masukan Unit </label>
        )}

      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Berdasarkan Unit"
            onChange={(e) => setQuery2(e.target.value.toLowerCase())}
          />
        )}

      <div className="table__wrapper_Scroll_Log">
        <table
          className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
          id="table-to-xls"
        >
          <thead>
            <tr>
              <th className="has-text-centered">No</th>
              <th className="has-text-centered">Kepangkatan</th>
              <th className="has-text-centered">Tanggal SK</th>
              <th className="has-text-centered">Masa Kerja</th>
              <th className="has-text-centered">
                Jenis Guru dan Karyawan Detail
              </th>
              <th
                className="has-text-centered"
                onClick={() => sorting("strStatus")}
              >
                Status <FaIcons.FaSort />
              </th>
              <th className="has-text-centered">Sertifikat Kepangkatan</th>
              <th className="has-text-centered">komentar</th>
              <th className="has-text-centered">Created by</th>
              <th className="has-text-centered">Unit</th>
              <th className="has-text-centered">Action</th>
            </tr>
          </thead>

          {pegawai &&
            (pegawai.strRole === "admin" ||
              pegawai.strRole === "kabid kepegawaian") && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) => (
                    <tr key={[riwayatKepangkatan.uuid]}>
                      {index === 0}
                      <td>{index + 1}</td>
                      <td>{riwayatKepangkatan.strKepangkatan}</td>
                      <td>
                        {moment(riwayatKepangkatan.dateTglSK).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                      <td>{riwayatKepangkatan.strMasaKerja}</td>
                      <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                      <td>{riwayatKepangkatan.strStatus}</td>
                      <td>
                        <a
                          href={riwayatKepangkatan.url}
                          download
                          onClick={(e) => download(e)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa fa-download" />
                          Sertifikat Kepangkatan
                        </a>
                      </td>
                      <td>{riwayatKepangkatan.strKomentar}</td>
                      <td>{riwayatKepangkatan.pegawai.strNama}</td>
                      <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                      <td>
                        <Link
                          to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}

          {pegawai && pegawai.strRole === "user" && (
            <tbody>
              {riwayatKepangkatans.map((riwayatKepangkatan, index) =>
                riwayatKepangkatan.strStatus ===
                  "Pengajuan Sertifikat Kepangkatan" ||
                riwayatKepangkatan.strStatus === "Ditolak Kabid Kepegawaian" ? (
                  <tr key={[riwayatKepangkatan.uuid]}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatKepangkatan.strKepangkatan}</td>
                    <td>
                      {moment(riwayatKepangkatan.dateTglSK).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>{riwayatKepangkatan.strMasaKerja}</td>
                    <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                    <td>{riwayatKepangkatan.strStatus}</td>
                    <td>
                      <a
                        href={riwayatKepangkatan.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Sertifikat Kepangkatan
                      </a>
                    </td>
                    <td>{riwayatKepangkatan.strKomentar}</td>
                    <td>{riwayatKepangkatan.pegawai.strNama}</td>
                    <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                    <td>
                      <Link
                        to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                        className="button is-small is-info"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() =>
                          deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                        }
                        className="button is-small is-danger"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ) : (
                  <tr key={[riwayatKepangkatan.uuid]}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatKepangkatan.strKepangkatan}</td>
                    <td>
                      {moment(riwayatKepangkatan.dateTglSK).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>{riwayatKepangkatan.strMasaKerja}</td>
                    <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                    <td>{riwayatKepangkatan.strStatus}</td>
                    <td>
                      <a
                        href={riwayatKepangkatan.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Sertifikat Kepangkatan
                      </a>
                    </td>
                    <td>{riwayatKepangkatan.strKomentar}</td>
                    <td>{riwayatKepangkatan.pegawai.strNama}</td>
                    <td>{riwayatKepangkatan.pegawai.strUnit}</td>
                    <td>-</td>
                  </tr>
                )
              )}
            </tbody>
          )}
          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 1" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit ===
                    "PAUD IT Al Hasanah 1" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 2" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit ===
                    "PAUD IT Al Hasanah 2" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 1" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit ===
                    "SDIT Al Hasanah 1" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}
          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 2" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit ===
                    "SDIT Al Hasanah 2" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMPI Al Hasanah" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit === "SMPI Al Hasanah" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}
          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMAIT Al Hasanah" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit === "SMAIT Al Hasanah" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}
          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "Pondok Pesantren" && (
              <tbody>
                {riwayatKepangkatans
                  .filter(
                    (riwayatKepangkatan) =>
                      riwayatKepangkatan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatKepangkatan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatKepangkatan, index) =>
                    riwayatKepangkatan.pegawai.strUnit ===
                    "Pondok Pesantren" ? (
                      <tr key={[riwayatKepangkatan.uuid]}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatKepangkatan.strKepangkatan}</td>
                        <td>
                          {moment(riwayatKepangkatan.dateTglSK).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatKepangkatan.strMasaKerja}</td>
                        <td>{riwayatKepangkatan.strGuruKaryawanDetail}</td>
                        <td>{riwayatKepangkatan.strStatus}</td>
                        <td>
                          <a
                            href={riwayatKepangkatan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Kepangkatan
                          </a>
                        </td>
                        <td>{riwayatKepangkatan.strKomentar}</td>
                        <td>{riwayatKepangkatan.pegawai.strNama}</td>
                        <td>{riwayatKepangkatan.pegawai.strUnit}</td>

                        <td>
                          <Link
                            to={`/riwayat-kepangkatan/edit/${riwayatKepangkatan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatKepangkatan(riwayatKepangkatan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}
        </table>
      </div>
    </div>
  );
};

export default RiwayatKepangkatanList;
